import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import "rc-pagination/assets/index.css";
import { useTranslation } from "react-i18next";
import {
  setSelectedCityDataResponse,
  setselectedCityResponse,
} from "../../redux/dashboard/reducer";
import ReactModal from "react-modal";
const CityPopUp = (props: any) => {
  const { cityData, city, setCity, setModalIsOpenToTrue } = props;
  // console.log("CITY!@#", city);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [modalIsOpenCity, setModalIsOpenCity] = useState<boolean>(false);
  // const CityId: string = useSelector((state: any) =>
  //   state.dashboard.selectedCity ? state.dashboard.selectedCity : ""
  // );
  const CityId: any = localStorage.getItem("oq:city");

  // const handleCityChange = async (e: any) => {
  //   const _selectedCity = cityData?.find(
  //     (ele: any) => ele?.Id == e.target.value
  //   );
  //   // console.log(_selectedCity, e.target.value, "==)(");

  //   dispatch(setselectedCityResponse(parseInt(e.target.value)));
  //   dispatch(setSelectedCityDataResponse(_selectedCity || {}));
  //   setCity(e.target.value);
  //   if (e.target.value === "") {
  //     localStorage.removeItem("oq:city");
  //   } else {
  //     localStorage.setItem("oq:city", e.target.value);
  //   }
  //   handleCloseModalCity();
  // };

  // useEffect(() => {
  //   if (!CityId) {
  //     setModalIsOpenCity(true);
  //   }
  // }, [CityId]);


  const handleCityChange = async (e: any) => {
  const selectedValue = e.target.value;
  const _selectedCity = cityData?.find((ele: any) => ele?.Id == selectedValue);

  dispatch(setselectedCityResponse(parseInt(selectedValue)));
  dispatch(setSelectedCityDataResponse(_selectedCity || {}));
  setCity(selectedValue);

  if (selectedValue === "") {
    localStorage.removeItem("oq:city");
  } else {
    localStorage.setItem("oq:city", selectedValue);
  }

  // Use timeout to ensure modal closes after React state and Redux update
  setTimeout(() => {
    handleCloseModalCity();
  }, 100);
};
useEffect(() => {
  const localCityId = localStorage.getItem("oq:city");
  if (!localCityId) {
    setModalIsOpenCity(true);
  }
}, []);


  const handleModalOpenCity = (code: any) => {
    setModalIsOpenCity(true);
  };
  const handleCloseModalCity = () => {
    setModalIsOpenCity(false);
  };

  /* var price = 0; */
  return (
    <div>
    <ReactModal
  isOpen={modalIsOpenCity}
  // onRequestClose={handleCloseModalCity}
  shouldCloseOnOverlayClick={false}
  style={{
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "450px",
      width: "90%",
      borderRadius: "8px",
      position: "relative",
      padding: "20px 20px 30px",
    },
  }}
>
  {/* ✖ Blue circular close icon */}
  {/* <button
    onClick={handleCloseModalCity}
    style={{
      position: "absolute",
      top: "0px",
      right: "0px",
      backgroundColor: "rgb(18 75 130)",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: "27px",
      height: "27px",
      fontSize: "22px",
      cursor: "pointer",
      lineHeight: "30px",
      textAlign: "center",
    }}
    aria-label="Close"
  >
    &times;
  </button> */}

  <h2>Please select a city</h2>
  <p className="mt-1">
    Please choose your city for which you want to book home collection/visit.
  </p>
  <div className="field for-w-100 cityBox-popUp">
    <select className="mt-4" value={city} onChange={handleCityChange}>
      <option value="">{t("select")}</option>
      {cityData &&
        cityData.length > 0 &&
        cityData.map((item: any, i: number) => (
          <option className="text-capitalize" value={item?.Id} key={i}>
            {t(item?.Name)}
          </option>
        ))}
    </select>
  </div>
</ReactModal>

    </div>
  );
};

export default CityPopUp;
